import { FC, useState, useEffect } from 'react';
import { Layout } from 'features/Layouts/Layouts';
import { MainTitle } from 'components/MainTitle';
import { InputSearch } from 'ui/InputSearch';
import { useGetTabPaginationEmployedsQuery } from 'redux/Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { EmployedsWorkSupportList } from 'components/EmployedsWorkSupportList';
import styles from './EmployedsContent.module.scss';
import useInfiniteScroll from 'react-infinite-scroll-hook';

interface QueryParams {
  page: number;
  per_page: number;
  search?: string;
}

export const EmployedsWorkSupportContent: FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const [allItems, setAllItems] = useState<any[]>([]);

  const per_page = 20;

  const [queryParams, setQueryParams] = useState<QueryParams>({
    page: 1,
    per_page,
  });

  const { data, isLoading } = useGetTabPaginationEmployedsQuery(queryParams);

  useEffect(() => {
    if (data?.data && Array.isArray(data.data)) {
      if (queryParams.page === 1) {
        setAllItems(data.data);
      } else {
        setAllItems((prev) => {
          const existingIds = new Set(prev.map((item) => item.id));
          const newItems = data.data.filter((item: any) => !existingIds.has(item.id));
          return [...prev, ...newItems];
        });
      }
    }
  }, [data]);

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      setQueryParams((prev) => ({
        ...prev,
        page: 1,
        search: searchValue || undefined,
      }));
      setAllItems([]);
    }
  };

  const hasNextPage = data?.meta
    ? data?.meta?.last_page !== data?.meta?.current_page
    : false;

  const [intersectionRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage,
    onLoadMore: () => setQueryParams((prev) => ({ ...prev, page: prev.page + 1 })),
    rootMargin: '0px 0px 800px 0px',
  });

  return (
    <Layout>
      <div className={styles.root}>
        <MainTitle title='Самозанятые' count={data?.meta.total} />
        <div className={styles.root_search}>
          <div className={styles.root_search_item}>
            <InputSearch
              notFocus
              placeholder='Искать'
              value={searchValue}
              onKeyDown={handleKeyDown}
              onSearch={() => {
                setQueryParams((prev) => ({
                  ...prev,
                  page: 1,
                  search: searchValue || undefined,
                }));
                setAllItems([]);
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSearchValue(e.target.value);

                if (e.target.value === '') {
                  setQueryParams((prev) => ({
                    ...prev,
                    page: 1,
                    search: undefined,
                  }));
                  setAllItems([]);
                }
              }}
            />
          </div>
        </div>
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
          <EmployedsWorkSupportList data={allItems} intersectionRef={intersectionRef} />
        )}
      </div>
    </Layout>
  );
};
